/*
  About page motion. Adds .is-visible to anything marked [data-ma-reveal]
  once it scrolls into view, which starts its fade-in and draws its doodles
  (styles in section-magnum-about.css). Runs once however many About
  sections include it.
*/
(function () {
  if (window.MagnumAbout) return;
  window.MagnumAbout = true;

  var root = document.documentElement;
  if (!root.classList.contains('ma-motion')) return;

  function reveal(el) {
    el.classList.add('is-visible');
  }

  function start() {
    var items = document.querySelectorAll('[data-ma-reveal]');

    if (!('IntersectionObserver' in window)) {
      items.forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.1 }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
